import { Component, OnInit } from '@angular/core';
import { SttTableComponent } from '../../../../shared/components/stt-table/stt-table.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UserModel } from '../../../../auth/models/user.model';
import { SuppliersAddEditComponent } from '../suppliers-add-edit/suppliers-add-edit.component';
import { SupplierModel } from '../../../../shared/entities/supplier.model';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ValidationMessageService } from '../../../../shared/services/base/validation-message-handle';
import { SupplierService } from '../../../../shared/services/app/supplier.service';
import { finalize } from "rxjs/operators";

@Component({
    selector: 'app-suppliers-action-table',
    templateUrl: './suppliers-action-table.component.html',
    styleUrls: ['./suppliers-action-table.component.scss']
})
export class SuppliersActionTableComponent implements OnInit {

    public data: any;
    public table: SttTableComponent;
    public ref: DynamicDialogRef;
    public loading = true;

    constructor(
        public dialogService: DialogService,
        public confirmationService: ConfirmationService,
        public primengConfig: PrimeNGConfig,
        public itemService: SupplierService,
        public messageService: MessageService,
        private validationMessageService: ValidationMessageService,
    ) {

    }

    ngOnInit(): void {
    }

    setParams(entity: UserModel): void {
        this.data = entity;
    }

    setTableReference(table: SttTableComponent): void {
        this.table = table;
    }


    showDialog() {
        this.ref = this.dialogService.open(SuppliersAddEditComponent, {
            header: 'Modificare furnizor',
            width: '70%',
            contentStyle: { 'max-height': '70vh' },
            baseZIndex: 10000,
            closeOnEscape: false,
            data: this.data,
        });

        this.ref.onClose.subscribe((supplier: SupplierModel) => {
            if (supplier) {
                this.table.refresh();
            }
        });
    }

    confirm() {
        this.confirmationService.confirm({
            header: 'Confirmare stergere Furnizor',
            message: 'Sunteti sigur ca doriti sa stergeti acest Furnizor?',
            key: 'deleteSupplier',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Da',
            rejectLabel: 'Nu',
            acceptButtonStyleClass: 'p-button-md p-button-success',
            rejectButtonStyleClass: 'p-button-md p-button-danger',
            accept: () => {
                this.deleteItem(this.data.uid);
            },
            reject: () => {
                this.confirmationService.close();
                this.table.refresh();
            }
        });
    }

    deleteItem(uid: string){
        this.itemService.delete(uid)
            .pipe(finalize(() => {this.loading = false;this.table.refresh();}))
            .subscribe((response: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Furnizorul a fost sters cu success!'
                });
            });
    }

}
